// eslint-disable-next-line no-shadow
enum EModoEnvioPin {
  SMS = 0,
  WHATSAPP = 1,
}

export default EModoEnvioPin
